var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_324_1081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.36761 0 0 5.367 0 12C0 18.6323 5.367 24 12 24C18.6324 24 24 18.633 24 12C24 5.36761 18.633 0 12 0ZM12 22.3256C6.30647 22.3256 1.67442 17.6936 1.67442 12C1.67442 6.30642 6.30647 1.67442 12 1.67442C17.6936 1.67442 22.3256 6.30642 22.3256 12C22.3256 17.6936 17.6936 22.3256 12 22.3256Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6448 15.1836C10.9814 15.1836 10.4443 15.7364 10.4443 16.3998C10.4443 17.0475 10.9656 17.6161 11.6448 17.6161C12.324 17.6161 12.861 17.0475 12.861 16.3998C12.861 15.7364 12.3082 15.1836 11.6448 15.1836Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.85 5.97461C9.71759 5.97461 8.73828 7.23831 8.73828 8.09125C8.73828 8.70728 9.25953 8.99162 9.686 8.99162C10.539 8.99162 10.1915 7.77531 11.8026 7.77531C12.5924 7.77531 13.2243 8.12284 13.2243 8.84945C13.2243 9.70239 12.3397 10.192 11.8184 10.6343C11.3603 11.0291 10.7601 11.6768 10.7601 13.0353C10.7601 13.8566 10.9813 14.0935 11.6289 14.0935C12.4028 14.0935 12.5608 13.7461 12.5608 13.4459C12.5608 12.6245 12.5766 12.1507 13.4454 11.4715C13.8718 11.1398 15.2144 10.0656 15.2144 8.58086C15.2144 7.09609 13.8718 5.97461 11.85 5.97461Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_324_1081"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.1b7208f326d5cd93f454c26da12ead47.svg";
export { ForwardRef as ReactComponent };